module.exports = __webpack_public_path__ + "assets/icon-clone-active.b99ca907.svg";